import React, { useMemo } from 'react';
import { List } from 'immutable';
import { Tag as TagData } from '../../../../../../../common/tags/tagTypes';
import TagListElement from './TagListElement';
import { getTags } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { generateTagsByBoardsArray } from '../tagUtils';

type Props = {
    handleToggleTagSelection: (tag: TagData) => void;
    handleClickEdit: (tag: TagData) => void;
    handleCreateCopyAndAddToElement: (tag: TagData) => void;
    elements: List<ImMNElement>;
    searchString: string;
    userRootPath: ImMNElement[];
    allTags: Tag[];
};

const TagLists = (props: Props) => {
    const { handleToggleTagSelection, handleClickEdit, elements, searchString, userRootPath, allTags } = props;

    const elementTagIds = elements.flatMap((element) => getTags(element) || []);
    const tagsByBoards = useMemo(
        () => generateTagsByBoardsArray(allTags, userRootPath, searchString),
        [allTags, userRootPath, searchString],
    );

    return (
        <div className="TagLists">
            {tagsByBoards.map(({ title, tags }, index) => {
                return (
                    <div key={index} className="mb-3">
                        {title && <p className="w-full text-left mb-1">{title}</p>}
                        {tags.map((tag) => {
                            return (
                                <TagListElement
                                    key={tag.id}
                                    tag={tag}
                                    isSelected={elementTagIds?.includes(tag.id)}
                                    handleClickTag={handleToggleTagSelection}
                                    handleClickEdit={handleClickEdit}
                                    size="sm"
                                />
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};

export default TagLists;
